"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TabbedView = exports.Tab = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _languageHandler = require("../../languageHandler");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Represents a tab for the TabbedView.
 */
var Tab =
/**
 * Creates a new tab.
 * @param {string} tabLabel The untranslated tab label.
 * @param {string} tabIconClass The class for the tab icon. This should be a simple mask.
 * @param {string} tabJsx The JSX for the tab container.
 */
exports.Tab = function Tab(tabLabel, tabIconClass, tabJsx) {
    (0, _classCallCheck3.default)(this, Tab);

    this.label = tabLabel;
    this.icon = tabIconClass;
    this.body = tabJsx;
}; /*
   Copyright 2017 Travis Ralston
   Copyright 2019 New Vector Ltd
   
   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at
   
       http://www.apache.org/licenses/LICENSE-2.0
   
   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
   */

var TabbedView = exports.TabbedView = function (_React$Component) {
    (0, _inherits3.default)(TabbedView, _React$Component);

    function TabbedView() {
        (0, _classCallCheck3.default)(this, TabbedView);

        var _this = (0, _possibleConstructorReturn3.default)(this, (TabbedView.__proto__ || (0, _getPrototypeOf2.default)(TabbedView)).call(this));

        _this.state = {
            activeTabIndex: 0
        };
        return _this;
    }

    (0, _createClass3.default)(TabbedView, [{
        key: "_getActiveTabIndex",
        value: function _getActiveTabIndex() {
            if (!this.state || !this.state.activeTabIndex) return 0;
            return this.state.activeTabIndex;
        }

        /**
         * Shows the given tab
         * @param {Tab} tab the tab to show
         * @private
         */

    }, {
        key: "_setActiveTab",
        value: function _setActiveTab(tab) {
            var idx = this.props.tabs.indexOf(tab);
            if (idx !== -1) {
                this.setState({ activeTabIndex: idx });
            } else {
                console.error("Could not find tab " + tab.label + " in tabs");
            }
        }
    }, {
        key: "_renderTabLabel",
        value: function _renderTabLabel(tab) {
            var _this2 = this;

            var classes = "mx_TabbedView_tabLabel ";

            var idx = this.props.tabs.indexOf(tab);
            if (idx === this._getActiveTabIndex()) classes += "mx_TabbedView_tabLabel_active";

            var tabIcon = null;
            if (tab.icon) {
                tabIcon = React.createElement("span", { className: "mx_TabbedView_maskedIcon " + tab.icon });
            }

            var onClickHandler = function onClickHandler() {
                return _this2._setActiveTab(tab);
            };

            return React.createElement(
                "span",
                { className: classes, key: "tab_label_" + tab.label,
                    onClick: onClickHandler },
                tabIcon,
                React.createElement(
                    "span",
                    { className: "mx_TabbedView_tabLabel_text" },
                    (0, _languageHandler._t)(tab.label)
                )
            );
        }
    }, {
        key: "_renderTabPanel",
        value: function _renderTabPanel(tab) {
            return React.createElement(
                "div",
                { className: "mx_TabbedView_tabPanel", key: "mx_tabpanel_" + tab.label },
                React.createElement(
                    "div",
                    { className: "mx_TabbedView_tabPanelContent" },
                    tab.body
                )
            );
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            var labels = this.props.tabs.map(function (tab) {
                return _this3._renderTabLabel(tab);
            });
            var panel = this._renderTabPanel(this.props.tabs[this._getActiveTabIndex()]);

            return React.createElement(
                "div",
                { className: "mx_TabbedView" },
                React.createElement(
                    "div",
                    { className: "mx_TabbedView_tabLabels" },
                    labels
                ),
                panel
            );
        }
    }]);
    return TabbedView;
}(React.Component);

TabbedView.propTypes = {
    // The tabs to show
    tabs: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Tab)).isRequired
};
//# sourceMappingURL=TabbedView.js.map